<template>
  <div class="flex flex-col w-full h-full items-center">
    <div class="flex flex-col h-full w-full overflow-auto">
      <template v-for="(user, index) in users">
        <div v-if="authUser.role === 'admin' || authUser.id === user.id" :key="index" class="flex flex-shrink-0 w-full items-center shadow-md bg-white text-gray-800 p-2 my-1">
          <div class="flex flex-col flex-1 p-2 text-left">
            <div class="text-sm font-bold uppercase">
              {{ user.name }}
            </div>
            <div class="text-xs font-thin font-serif lowercase">
              {{ user.email }}
            </div>
          </div>
          <router-link :to="'/user/'+user.id+'/schedule'" class="w-10 p-1 self-center">
            <svg class="h-8 w-8 fill-current text-gray-700" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M400 64h-48V12c0-6.627-5.373-12-12-12h-8c-6.627 0-12 5.373-12 12v52H128V12c0-6.627-5.373-12-12-12h-8c-6.627 0-12 5.373-12 12v52H48C21.49 64 0 85.49 0 112v352c0 26.51 21.49 48 48 48h352c26.51 0 48-21.49 48-48V112c0-26.51-21.49-48-48-48zM48 96h352c8.822 0 16 7.178 16 16v48H32v-48c0-8.822 7.178-16 16-16zm352 384H48c-8.822 0-16-7.178-16-16V192h384v272c0 8.822-7.178 16-16 16zm-66.467-194.937l-134.791 133.71c-4.7 4.663-12.288 4.642-16.963-.046l-67.358-67.552c-4.683-4.697-4.672-12.301.024-16.985l8.505-8.48c4.697-4.683 12.301-4.672 16.984.024l50.442 50.587 117.782-116.837c4.709-4.671 12.313-4.641 16.985.068l8.458 8.527c4.672 4.709 4.641 12.313-.068 16.984z" /></svg>
          </router-link>
          <router-link :to="'/user/'+user.id+'/report'" class="w-10 p-1 self-center">
            <svg class="h-8 w-8 fill-current text-gray-700" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><path d="M369.9 97.9L286 14C277 5 264.8-.1 252.1-.1H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V131.9c0-12.7-5.1-25-14.1-34zm-22.6 22.7c2.1 2.1 3.5 4.6 4.2 7.4H256V32.5c2.8.7 5.3 2.1 7.4 4.2l83.9 83.9zM336 480H48c-8.8 0-16-7.2-16-16V48c0-8.8 7.2-16 16-16h176v104c0 13.3 10.7 24 24 24h104v304c0 8.8-7.2 16-16 16zm-48-244v8c0 6.6-5.4 12-12 12H108c-6.6 0-12-5.4-12-12v-8c0-6.6 5.4-12 12-12h168c6.6 0 12 5.4 12 12zm0 64v8c0 6.6-5.4 12-12 12H108c-6.6 0-12-5.4-12-12v-8c0-6.6 5.4-12 12-12h168c6.6 0 12 5.4 12 12zm0 64v8c0 6.6-5.4 12-12 12H108c-6.6 0-12-5.4-12-12v-8c0-6.6 5.4-12 12-12h168c6.6 0 12 5.4 12 12z" /></svg>
          </router-link>
        </div>
      </template>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'User',
  computed: {
    ...mapGetters('auth', ['authUser']),
    ...mapGetters('user', ['users'])
  },
  mounted () {
    this.get({
      params: {
        project_id: this.authUser.project.id
      }
    })
  },
  methods: {
    ...mapActions('user', ['get'])
  }
}
</script>
